import { ENV_VARIABLES } from '@/constants';

import {
  DATADOG_DISABLED_LOCAL_MESSAGE,
  DATADOG_MISCONFIGURED_MESSAGE,
  LOCAL_ENVIRONMENTS
} from './constants';

/**
 * Reports that Datadog could not start. In a deployed environment a skip is
 * surfaced at `error` level (rather than `warn`) so a misconfiguration that
 * silently disables all monitoring is unmistakable.
 */
const reportMissingDatadogCredentials = () => {
  if (LOCAL_ENVIRONMENTS.includes(ENV_VARIABLES.ENVIRONMENT)) {
    console.warn(DATADOG_DISABLED_LOCAL_MESSAGE);

    return;
  }

  console.error(
    `${DATADOG_MISCONFIGURED_MESSAGE} (env: ${ENV_VARIABLES.ENVIRONMENT})`
  );
};

export default reportMissingDatadogCredentials;
